import { CheckCircleFilled } from "@ant-design/icons";
import { Button } from "antd";
import PropTypes from "prop-types";

const SuccessMessage = ({ onFinish, isEdit }) => {
  return (
    <div className="flex flex-col gap-3 align-middle items-center pt-14 pb-6 px-4">
      <CheckCircleFilled style={{ fontSize: "110px", color: "#507D2A" }} />
      <div className="text-center">
        <h2 className="font-semibold m-0 p-0 text-2xl">{isEdit ? "Successfully Saved" : "Success!"}</h2>
        <p className="p-0 m-0">
          {isEdit ? (
            <>
              Your changes have been <br /> successfully saved
            </>
          ) : (
            <>
              Your creation of Job opening has been <br /> successfully posted
            </>
          )}
        </p>
      </div>
      <div className="w-full mt-6">
        <Button
          block
          type="primary"
          className="h-10 border-none font-semibold rounded-2xl shadow-md hover:bg-[#d5621e]"
          style={{
            backgroundColor: "#F45F0C",
            letterSpacing: "1px",
          }}
          onClick={onFinish}
        >
          DONE
        </Button>
      </div>
    </div>
  );
};

SuccessMessage.propTypes = {
  onFinish: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

export default SuccessMessage;
